import { network } from '../configuration';

export const getImageUrl = (relativeImageUrl: string): string => {
  return `${network.host}${relativeImageUrl}`;
};
